// extracted by mini-css-extract-plugin
module.exports = {"root":"List_root__xL90w","heading":"List_heading__fIy3l"};